module.exports = __webpack_public_path__ + "img/visa-dark.8927c7b0.svg";